
const colors = {'connected': '#163c5d', 'focused': '#163c5d', 'align': '#163c5d', 'clear': '#163c5d', 'understood': '#163c5d', 
'role': '#163c5d', 'swot': '#163c5d', 'equip': '#163c5d', 'data': '#163c5d', 'achieve': '#1f9e6c', 'purpose': '#1f9e6c', 'dedicate': 
'#1f9e6c', 'motivated': '#1f9e6c', 'inspire': '#1f9e6c', 'culture': '#1f9e6c', 'connect': '#1f9e6c', 'aligned': '#1f9e6c', 'priority': 
'#ffb236', 'factors': '#ffb236', 'contributes': '#ffb236', 'capabilities': '#ffb236', 'learning': '#ffb236', 'processes': '#ffb236', 
'reviews': '#ffb236', 'challenge': '#008bae', 'visible': '#008bae', 'team': '#008bae', 'perform': '#008bae', 'review': '#008bae', 
'responsibility': '#008bae', 'identify': '#008bae', 'implement': '#008bae'}

export const colorMap = new Map (Object.entries(colors))